export default `.RedactionTool, header:not(div):not(span):not(div){
background: rgb(154, 154, 154);
}
[data-redactable="true"]:not(:empty){
user-select: text;
box-shadow: 0px 6px 12px rgba(0,0,0,.3);
background-color: #fff;
transition: none
}
[data-redactable="true"][data-redactable="true"][data-redactable="true"]:not(:empty) *{
user-select: text;
background-color: #fff;
transition: none;
}`
